export const EVENTS = {
  SECTION_VIEW: 'section_view',
  SECTION_ENGAGEMENT_START: 'section_engagement_start',
  SECTION_ENGAGEMENT_END: 'section_engagement_end',
  SCROLL_DEPTH: 'scroll_depth',
  FUNNEL_STEP: 'funnel_step',
  FUNNEL_COMPLETE: 'funnel_complete',
  SESSION_EXIT: 'session_exit',
  ABANDON_BEFORE_CONTACT: 'abandon_before_contact',
  ELEMENT_CLICK: 'element_click',
  NAV_CLICK: 'nav_click',
  CONTACT_LINK_CLICK: 'contact_link_click',
  PROJECT_CARD_CLICK: 'project_card_click',
  PROJECT_MODAL_OPEN: 'project_modal_open',
  PROJECT_MODAL_CLOSE: 'project_modal_close',
  PROJECT_MODAL_NAV: 'project_modal_nav',
  PROJECT_LINK_CLICK: 'project_link_click',
  GALLERY_INTERACTION: 'gallery_interaction',
  CONSENT_CHOICE: 'consent_choice',
  ABOUT_PHOTO_SLIDER_CLICK: 'about_photo_slider_click',
  MODAL_CLOSE: 'modal_close',
  WEB_VITAL: 'web_vital',
};

export const FUNNEL_SECTIONS = ['home', 'about', 'projects', 'contact'];

export const SCROLL_MILESTONES = [25, 50, 75, 90, 100];
